// @core/api/endpoints/team/create_team_join_application.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTeamJoinApplicationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Request to join team
 * Submits a request to join a team. Team admins are notified and can approve or reject the application.
 */
export async function CreateTeamJoinApplication(
  team_id: string,
  data: CreateTeamJoinApplicationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/join-applications`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
